export default "__VITE_ASSET__BT0nlUU4__"